import { Button, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UrlPathCampaignExperimentalCreate } from "../../api/url";
import { canMaintainCoupons } from "../../store/actions/LoginActions";
import MenuLayout from "../app/MenuLayout";
import CampaignTable from "./CampaignTable";

export const CampaignPage = () => {
  const { t } = useTranslation();

  return (
    <MenuLayout headline={t('campaignExperimental.overview.title')} subHeadline={t('campaignExperimental.overview.subtitle')}>
      <Grid container spacing={2}>
        {canMaintainCoupons() && (
          <Grid container item justifyContent="flex-end">
            <Button component={Link} to={UrlPathCampaignExperimentalCreate} startIcon="+" variant="contained" color="primary">
              {t('campaignExperimental.overview.newCampaign')}
            </Button>
          </Grid>
        )}
        <Grid item md={12}>
          <CampaignTable />
        </Grid>
      </Grid>
    </MenuLayout>
  );
};